import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/AddBilling.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import AddLedgerEntry from "./AddLedgerEntry";
import { FaEye } from "react-icons/fa6";
import { capitalize } from "../../utils/capitalize";
import { useGetCustomerJournalsQuery, useSendCreditsmsMutation } from "../../slices/admin/admin";
import { toast } from "react-toastify";

const ViewLadger = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const customerId = searchParams.get("id");
    const mode = searchParams.get("mode");

    const { data, isLoading, isError } = useGetCustomerJournalsQuery({
        customerId,
        offset: currentPage,
        limit,
    }, { skip: !customerId });

    const [sendCreditsms, { isLoading: isSending }] = useSendCreditsmsMutation();

    const handleNotify = async () => {
        if (!data?.totalCreditAmount || !customer?.phone) {
            toast.error("Required information (amount or phone) is missing");
            return;
        }

        try {
            const response = await sendCreditsms({
                amount: data.totalCreditAmount,
                phone: customer.phone,
            }).unwrap();

            if (response.success) {
                toast.success(response.message || "Notification sent successfully");
            } else {
                toast.error(response.message || "Failed to send notification");
            }
        } catch (error) {
            toast.error(error?.data?.message || "Something went wrong while sending SMS");
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [limit]);

    const closePopup = () => setShowPopup(false);

    const customer = data?.customerDetails;
    const transactions = data?.journals || [];
    const totalPages = Math.ceil((data?.total || 0) / limit);

    return (
        <div className={styles.billingContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>View Sales Ledger</h2>
                <span
                    className={styles.closeIcon}
                    onClick={() => navigate("/dashboard/Ledger?activeTab=receivable")}
                >
                    ✕
                </span>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.formSection}>
                    <div className={styles.ownerBoxxx}>
                        <p>
                            <strong>Item Owner :</strong> {customer?.firstName || "-"}
                        </p>
                        <p>
                            <strong>Store Name :</strong> {customer?.storeName || "-"}
                        </p>
                        <p>
                            <strong>Phone No :</strong> {customer?.phone || "-"}
                        </p>
                        <div className={styles.creditBadgeContainer}>
                            <strong>Total Credit Amount :</strong>
                            <span className={`${styles.statusRejected} ${styles.pillBadge}`}>
                                ₹{data?.totalCreditAmount?.toLocaleString() || 0}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.itemsHeader}>
                    <h4>Transactions</h4>
                    <div style={{ display: 'flex' }}>
                        {(data?.totalCreditAmount || 0) > 0 && (
                            <button
                                className={styles.notifyBtn}
                                onClick={handleNotify}
                                disabled={isSending}
                            >
                                {isSending ? "Sending..." : "Notify"}
                            </button>
                        )}
                        <button
                            className={styles.addItemBtn}
                            onClick={() => setShowPopup(true)}
                        >
                            + Debit Amount
                        </button>
                    </div>
                </div>

                <div className={styles.itemsSection}>
                    {isLoading ? (
                        <p>Loading...</p>
                    ) : isError ? (
                        <p>Error loading transactions</p>
                    ) : (
                        <div className={styles.tableWrapper}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Journal ID</th>
                                        <th>Receipt ID</th>
                                        <th>Transaction Date</th>
                                        <th>Payment Status</th>
                                        <th>Payment Method</th>
                                        <th>Handle By</th>
                                        <th>Credit</th>
                                        <th>Debit</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions.map((txn) => (
                                        <tr key={txn._id}>
                                            <td className="notranslate">{txn.journalId}</td>
                                            <td className="notranslate">{txn?.billingInfo?.receiptNo || "Journal"}</td>
                                            {/* <td>
                                                {new Date(txn.createdAt).toLocaleDateString("en-US")}
                                            </td> */}
                                            <td>
                                                {new Date(txn.createdAt).toLocaleString("en-US", {
                                                    year: "numeric",
                                                    month: "numeric",
                                                    day: "numeric",
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })}
                                            </td>


                                            <td>
                                                <span className={`${styles.status} ${txn.paymentStatus?.toLowerCase() === "paid"
                                                        ? styles.statusApproved
                                                        : txn.paymentStatus?.toLowerCase() === "pending"
                                                            ? styles.statusRejected
                                                            : styles.statusDefault
                                                    }`}>
                                                    {txn.paymentStatus ? capitalize(txn.paymentStatus) : '-'}
                                                </span>
                                            </td>

                                            <td>{txn.paymentMethod}</td>
                                            <td>
                                                {txn.handleBy
                                                    ? `${txn.handleBy.firstName || ""} ${txn.handleBy.lastName || ""}`.trim()
                                                    : "-"}
                                            </td>
                                            <td>₹{txn.credit}</td>
                                            <td>₹{txn.debit}</td>
                                            <td>
                                                <div className={styles.actions}>
                                                    {txn.journalType !== "Journal" ? (
                                                        <FaEye
                                                            className={styles.icon}
                                                            onClick={() =>
                                                                navigate(
                                                                    `/dashboard/ViewItems?id=${customerId}&journalId=${txn._id}&mode=view`
                                                                )
                                                            }
                                                        />
                                                    ) : (
                                                        <span>Journal</span>
                                                    )}
                                                </div>
                                            </td>


                                        </tr>
                                    ))}

                                    {transactions.length === 0 && (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: "center" }}>
                                                No transactions found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div className={styles.dflexamount}>
                                <div>
                                    <h3>Total Credit Amount :</h3>
                                </div>
                                <div>
                                    <h3>₹{data?.totalCreditAmount || 0}</h3>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => setLimit(Number(e.target.value))}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>

                <div className={styles.footerButtons}>
                    <button
                        className={styles.cancelBtn}
                        onClick={() => navigate("/dashboard/Ledger?activeTab=receivable")}                    >
                        Close
                    </button>
                </div>
            </div>

            {showPopup && (
                <PopupWrapper onClose={closePopup}>
                    <AddLedgerEntry onClose={closePopup} />
                </PopupWrapper>
            )}
        </div>
    );
};

export default ViewLadger;
